import { render, staticRenderFns } from "./areaContent.vue?vue&type=template&id=957b6df8&"
import script from "./areaContent.vue?vue&type=script&lang=js&"
export * from "./areaContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports